<template>
  <div>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหา</span>
      <v-autocomplete
        v-model="keywordSearch"
        :items="itemSearch"
        item-text="name"
        item-value="name"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหา"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @click:clear="keywordSearch='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="button-color-outline head-search-button"
            style="width: 96px; height: 38px;"
            text
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สิทธิ์</span>
              <v-autocomplete
                v-model="selectAuthenList"
                :items="itemAuthenList"
                item-text="name"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @click:clear="selectAuthenList=[], searchFilterData(), page=1"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สถานะ</span>
              <v-autocomplete
                v-model="selectAuthenStatusList"
                :items="itemStatusList"
                item-text="name"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @click:clear="selectAuthenStatusList=[], searchFilterData(), page=1"
              >
              <template v-slot:[`item`]="{ item }">
                <span style="color: rgba(0, 0, 0, 0.87);">{{ statusList.filter(e => e.status === item)[0].statusTH || '-' }}</span>
              </template>
              <template #selection="{ item }">
                <span style="color: rgba(0, 0, 0, 0.87);">{{ statusList.filter(e => e.status === item)[0].statusTH || '-' }}</span>
              </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="d-flex">
            <v-spacer/>
            <v-btn
              class="button-color-outline head-search-button mr-2"
              outlined
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color ml-2 mr-3"
              style="width: 94px;"
              dark
              @click="searchFilterData()"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getSelectApproveRequestCompany
} from '@/API/API'
// import axios from 'axios'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  data () {
    return {
      tapData: ['', 'waiting', 'pending', 'approve', 'reject'],
      tapSelect: 0,
      keywordSearch: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      itemSearch: [],
      itemPosition: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemRequestType: [],
      selectAuthenList: [],
      selectAuthenStatusList: [],
      itemAuthenList: [],
      itemStatusList: [],
      filterData: {
        search: '',
        selectAuthenList: [],
        selectRoleStatus: [],
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        companyName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รอการอนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      menu1: false,
      datesUpdateAt: [],
      datesCreateAt: [],
      menu2: false,
      createAt: '',
      updateAt: '',
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      approveRole: localStorage.approveRole,
      statusList: [
        { status: 'pending', statusTH: 'ยังไม่โอน', color: '#E9A016' },
        { status: 'approve', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  watch: {
  },
  computed: {
  },
  async created () {
    // await this.getSelectData()
    await this.searchFilterData()
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    EventBus.$on('getFilterฺRoleReceive', this.getSelectValue)
    EventBus.$on('updateTotalCom', this.updateTotal)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  beforeDestroy () {
    EventBus.$off('manageApproveComSearch')
    EventBus.$off('updateTotalCom')
    EventBus.$off('setApproveRole')
  },
  methods: {
    gotocreate () {
      // this.$router.push('managebusines/create')
      this.$router.push({
        name: 'manageTransferrolecreate',
        params: {
          type: 'new',
          id: ''
        }
      })
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      // await this.getSelectData()
      await this.searchFilterData()
    },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
    },
    getSelectValue (filter) {
      this.itemSearch = filter.result[0].name
      this.itemAuthenList = filter.result[0].authen
      this.itemStatusList = filter.result[0].status
    },
    async getSelectData () {
      try {
        // const res = await getSelectApproveRequestCompany({ approveType: this.mode, role: this.approveRole }, this.$store.state.token)
        const res = await getSelectApproveRequestCompany(this.$store.state.token)
        if (res.success) {
          if (res.result) {
            this.itemCompanyName = res.result
            this.itemGroupCompanyName = res.result.groupCompanyList
            this.itemPosition = res.result.positionList
            this.itemRequestType = res.result.requestTypeList
            this.itemSearch = res.result
          }
        }
      } catch (error) {
      } finally {
      }
    },
    resetUpdateDate () {
      this.updateAt = ''
      this.datesUpdateAt = []
      this.searchFilterData(1, 15)
    },
    resetCreateDate () {
      this.createAt = ''
      this.datesCreateAt = []
      this.searchFilterData(1, 15)
    },
    resetFilterData () {
      this.selectAuthenStatusList = ''
      this.selectAuthenList = []
      this.keywordSearch = ''
      this.keywordRequestNo = ''
      this.keywordPosition = []
      this.keywordType = []
      this.keywordCompanyName = []
      this.keywordGroupCompanyName = []
      this.createAt = ''
      this.updateAt = ''
      this.datesUpdateAt = []
      this.datesCreateAt = []
      this.filterData = {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode
      }
      this.searchFilterData(1, 15)
    },
    searchFilterData () {
      this.filterData = {
        search: this.keywordSearch,
        authenId: [this.selectAuthenList],
        status: [this.selectAuthenStatusList],
        role: this.approveRole
      }
      EventBus.$emit('roleReceiveSearch', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-employee {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  /* position: absolute; */
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
